exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-planner {\n  margin-top: 20px; }\n  .menu-planner .content {\n    border-left: #eeeeee 1px solid; }\n    .menu-planner .content .recipes {\n      margin-top: 0; }\n      .menu-planner .content .recipes .page-header {\n        margin-top: 0; }\n\n.menu-complete-btn {\n  border-radius: 0 0 0 2px !important;\n  width: 100%; }\n  .menu-complete-btn .glyphicon-ok {\n    margin-left: 10px; }\n\n.menu-edit-btn {\n  border-radius: 0 0 2px 0 !important;\n  width: 100%; }\n  .menu-edit-btn .glyphicon-ok {\n    margin-left: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./modules/menu/css/menu.scss
// module id = 596
// module chunks = 0